import { SmallDownArrow, SmallRightArrow } from 'components/Icons';
import React from 'react';

interface Props {
  isExpanded?: boolean;
  indent?: number;
  marginRight?: number;
  /** Pass custom icon/element in place of expand/collapse arrows. Ignores isExpanded when used. */
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

/**
 * Provides the indent often needed on "sub table rows", and
 * an icon (expand/collapse rows by default, pass child to overwrite).
 */
export const TableIdenticator: React.FC<Props> = ({
  isExpanded,
  marginRight,
  indent,
  style,
  children,
}) => {
  return (
    <span style={{ display: 'flex', marginRight, marginLeft: indent, width: 20, ...style }}>
      {children ? children : <>{isExpanded ? <SmallDownArrow /> : <SmallRightArrow />}</>}
    </span>
  );
};

export default TableIdenticator;
